export default {
  requestLetter: {},
  requestLetters: [],
}
